import adobexd from '../assets/adobexd.png'
import asana from '../assets/asana.png'
import bitbucket from '../assets/bitbucket.png'
import canva from '../assets/canva.png'
import figma from '../assets/figma.png'
import github from '../assets/github.png'
import outlook from '../assets/outlook.png'
import photoshop from '../assets/photoshop.png'
import slack from '../assets/slack.png'
import teams from '../assets/teams.svg'
import trello from '../assets/trello.png'
import vscode from '../assets/vscode.png'

const getTools = [
    {
        toolName: 'adobeXD',
        toolImg: adobexd
    },
    {
        toolName: 'asana',
        toolImg: asana
    }, {
        toolName: 'bitbucket',
        toolImg: bitbucket
    },
    {
        toolName: 'canva',
        toolImg: canva
    },
    {
        toolName: 'figma',
        toolImg: figma
    },
    {
        toolName: 'github',
        toolImg: github
    },
    {
        toolName: 'outlook',
        toolImg: outlook
    },
    {
        toolName: 'photoshop',
        toolImg: photoshop
    },
    {
        toolName: 'teams',
        toolImg: teams
    },
    {
        toolName: 'slack',
        toolImg: slack
    },
    {
        toolName: 'trello',
        toolImg: trello
    },
    {
        toolName: 'vscode',
        toolImg: vscode
    }
]
export default getTools;